import { useState } from "react";
import { FilterState } from "@/components/grid/filter_bar";


const useFilterActions = () => {

  const [filters, setFilters] = useState<FilterState>({});

  const setFilter = (field: string, values: string[]) => {
    setFilters((prev) => ({ ...prev, [field]: values }));
  };

  const resetFilters = () => {
    setFilters({});
  };

  return {
    filters,
    setFilter,
    resetFilters,
    setFilters
  };
};

export default useFilterActions;